export default "/images/framework/ReesIcon.ed4f3bc0.svg?ed4f3bc0";